export const aboutText = `The International Centre for Dispute Resolution (ICDR) is 
a British based international dispute resolution service provider.`